import React, { useState } from "react";

import "./App.css";
import Card from "./Card";
import CompareTable from "./CompareTable";

import IN6001 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-6001HD_white.webp";
import IN6012 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-6012HD_white.webp";
import IN6014 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-6014HD_white.webp";
import IN8001 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-8001HD_white.webp";
import IN8003 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-8003HD_white.webp";
import IN8015 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-8015HD_white.webp";
import IN8401 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-8401WQHD_white.webp";
import IN8403 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-8403WQHD_white.webp";
import IN8415 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-8415WQHD_white.webp";
import IN8815 from "../../../images/Products/Compare/Wiki_Tiles_P-IN-8815QFHD_white.webp";

import data from "./indoor_data";

const cameras = data;

function CompareIndoor() {
  const [compareArray, setCompareArray] = useState([]);

  let setCompareState = (camera) => {
    for (let i = 0; i < compareArray.length; i++) {
      if (camera.name === compareArray[i].name) return null;
    }
    let newArray = [...compareArray, camera];
    setCompareArray(newArray);
  };

  let removeFromArray = (camera) => {
    let newArray = [...compareArray];

    for (let i = 0; i < compareArray.length; i++) {
      if (camera.name === compareArray[i].name) newArray.splice(i, 1);
    }

    setCompareArray(newArray);
  };

  return (
    <div className="wrapper">
      <div className="cards">
        <Card
          specifications={cameras[0]}
          image={IN6001}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[1]}
          image={IN6012}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[2]}
          image={IN6014}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[3]}
          image={IN8001}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[4]}
          image={IN8003}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[5]}
          image={IN8015}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[6]}
          image={IN8401}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[7]}
          image={IN8403}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[8]}
          image={IN8415}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
        <Card
          specifications={cameras[9]}
          image={IN8815}
          compare={setCompareState}
          entfernen={removeFromArray}
        />
      </div>
      <CompareTable compareItems={compareArray} />
    </div>
  );
}

export default CompareIndoor;
